module.exports = __webpack_public_path__ + "img/chevron_down_icon.598d99e0.svg";